import React from 'react';
import { FaArrowRight, FaMapMarkerAlt, FaRoute } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../css/walkingHikingTours.css'; // Import custom styles
import NavBar from './nav';
import Footer from './footer';
import { findJourneyItem } from './journeyData';

const WalkingHikingTours = () => {
  const navigate = useNavigate();
  // List of hiking spots around Kimberley
  const hikingSpots = [
    {
      slug: "kamfers-dam",
      name: "Kamfers Dam",
      description: "A haven for bird watchers and nature lovers, Kamfers Dam is home to thousands of flamingos. The walking trails around the dam offer stunning views and a peaceful atmosphere.",
      image: require("../assets/KamferDam.jpg"), // Replace with actual image path
    },
    {
      slug: "mokala-national-park",
      name: "Mokala National Park",
      description: "Mokala National Park offers a variety of hiking trails through diverse landscapes, including savannahs, rocky hills, and riverine forests. It's a great spot for wildlife enthusiasts.",
      image: require("../assets/mokala-national-park-entrance-sign-01-500x300.jpg"),
    },
    {
      slug: "the-big-hole-walks",
      name: "The Big Hole",
      description: "While primarily known for its historical significance, the area around The Big Hole also offers scenic walking paths with views of the iconic landmark and surrounding landscapes.",
      image: require("../assets/Fallback/Big Hole/bigHole04.jpg"),
    },
    {
      slug: "magersfontein-battlefield",
      name: "Magersfontein Battlefield",
      description: "This historical site offers walking trails that take you through the battlefield, providing insights into the Anglo-Boer War while enjoying the natural beauty of the area.",
      image: require("../assets/Fallback/Magersfontein Battlefield/magersfonteinBattlefield05.jpg"),
    },
    {
      slug: "rooipoort-nature-reserve",
      name: "Rooipoort Nature Reserve",
      description: "Rooipoort offers rugged hiking trails through pristine wilderness, with opportunities to spot wildlife like antelopes, zebras, and a variety of bird species.",
      image: require("../assets/PL-RooiPoort.jpg"), // Replace with actual image path
    }
  ];

  const openDetails = (spot) => {
    const item = findJourneyItem(spot.slug);
    navigate(`/journey/${spot.slug}`, { state: { item } });
  };

  return (
    <div className="walking-page">
      <NavBar />
      
      {/* Hero Section */}
      <div className="hero-section">
        <h1 className="hero-title">Explore Kimberley's Best Hiking Trails</h1>
        <p className="hero-subtitle">Discover scenic routes, historical landmarks, and breathtaking views.</p>
      </div>

      {/* Hiking Tours Section */}
      <div className="walking-hiking-tours">
        <div className="walking-section-header">
          <p className="walking-eyebrow">
            <FaRoute /> Curated outdoor routes
          </p>
          <h1 className="section-title">Walking & Hiking Tours in Kimberley</h1>
          <p className="section-subtitle">
            Explore scenic trails, nature stops, and historical landmarks around the city.
          </p>
        </div>
        
        <div className="hiking-spots-grid">
          {hikingSpots.map((spot, index) => (
            <div key={index} className="hiking-spot-card">
              <div className="hiking-spot-image-container">
                <img src={spot.image} alt={spot.name} className="hiking-spot-image" />
                <span className="hiking-card-chip">
                  <FaMapMarkerAlt /> Kimberley
                </span>
              </div>
              <div className="hiking-spot-content">
                <span className="hiking-card-kicker">Route {index + 1}</span>
                <h2 className="hiking-spot-name">{spot.name}</h2>
                <p className="hiking-spot-description">{spot.description}</p>
                <button type="button" className="visit-button-2" onClick={() => openDetails(spot)}>
                  Learn More <FaArrowRight />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default WalkingHikingTours;
